import {TypographyProps} from '@mui/material'
import {Typography} from './Typography'

export const Caption = ({...props}: Omit<TypographyProps, 'variant'>) => {
    return <Typography variant="caption" {...props}/>
}